"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.util = exports.FormatUtils = exports.constants = exports.schema = exports.marks = exports.nodes = exports.types = void 0;
const schema_1 = require("./schema");
Object.defineProperty(exports, "nodes", { enumerable: true, get: function () { return schema_1.nodes; } });
Object.defineProperty(exports, "marks", { enumerable: true, get: function () { return schema_1.marks; } });
const DbSchema_1 = require("./DbSchema");
// legacy top-level exports: types, nodes, marks, schema, constants
var constants_1 = require("./schema/constants");
Object.defineProperty(exports, "types", { enumerable: true, get: function () { return constants_1.LEGACY_TYPES; } });
const schema = (0, schema_1.createSchema)(schema_1.nodes, schema_1.marks);
exports.schema = schema;
const constants = {
    OrgOptionType: DbSchema_1.OrgOptionMap,
    OrgPermissionType: DbSchema_1.OrgPermissionMap,
    TierType: DbSchema_1.OrgTierMap,
    ScriptStatusType: DbSchema_1.ScriptStatusMap,
};
exports.constants = constants;
// modern/preferred exports
__exportStar(require("./DbSchema"), exports);
__exportStar(require("./ScriptSchema"), exports);
exports.FormatUtils = __importStar(require("./script-formats"));
exports.util = __importStar(require("./util"));
__exportStar(require("./types"), exports);
